import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  // Color style
  palette: {
    primary: {
      main: '#003c6f',
      contrastText: '#fff',
    },
    secondary: {
      main: '#a29c99',
      contrastText: '#fff',
    },
    tertiary: {
      main: '#61B3CD',
      contrastText: '#fff',
    },
  },
  // Fonts style
  typography: {
    fontFamily: ['Lato', 'sans-serif'].join(','),
    h1: {
      fontSize: 28,
      fontWeight: 900,
      color: '#19191a',
      wordBreak: 'break-word',
    },
    h2: {
      fontSize: 20,
      fontWeight: 700,
      color: '#19191a',
      wordBreak: 'break-word',
    },
    h3: {
      fontSize: 18,
      fontWeight: 700,
      color: '#4B403A',
      wordBreak: 'break-word',
    },
    h4: {
      fontSize: 16,
      fontWeight: 700,
      color: '#4B403A',
      wordBreak: 'break-word',
    },
    h5: {
      fontSize: 14,
      fontWeight: 700,
      color: '#4B403A',
      wordBreak: 'break-word',
    },
    h6: {
      fontSize: 12,
      fontWeight: 400,
      color: '#4B403A',
      wordBreak: 'break-word',
    },
    subtitle1: {
      fontSize: 13,
      fontWeight: 700,
      color: '#4e5054',
    },
    body1: {
      fontSize: 13,
      fontWeight: 400,
      color: '#4e5054',
    },
    body2: {
      fontSize: 13,
      fontWeight: 400,
      color: '#868787',
    },
    caption: {
      color: '#4E5054',
    },
  },
  // Button style
  // forms style
  // Overrides style - button, forms

  overrides: {
    MuiList: {
      padding: {
        paddingTop: '0px',
        paddingBottom: '0px',
      },
    },

    MuiDrawer: {
      paperAnchorDockedLeft: {
        borderRight: 'none',
      },
    },

    MuiDivider: {
      root: {
        marginTop: '10px',
        marginBottom: '10px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        height: 'auto',
        background: 'none',
      },
    },

    MuiButton: {
      root: {
        borderRadius: 5,
        padding: '5px 10px',
        fontSize: 11,
        fontWeight: 700,
        lineHeight: 1,
        minWidth: 160,
        textTransform: 'capitalize',
        minHeight: '32px',
        '@media (max-width:960px)': {
          borderRadius: 10,
          padding: '12px 35px',
          fontSize: 14,
        },
      },
      contained: {
        color: '#FFFFFF',
        backgroundColor: 'rgba(162, 156, 153, 1)',
        minWidth: '120px',
      },
      outlined: {
        color: '#003C6F',
        backgroundColor: '#fff',
        minWidth: 'auto',
        border: '1px solid #003C6F',
        minHeight: '32px',
        '&:hover': {
          backgroundColor: '#fff',
          color: '#003C6F',
        },
      },
      outlinedSecondary: {
        color: '#616569',
        border: '1px solid #92979d',
        '&:hover': {
          backgroundColor: '#fff',
          color: '#616569',
        },
      },
    },
    MuiListItem: {
      button: {
        '&:hover': {
          backgroundColor: 'rgba(72, 96, 207, 0.1)',
          color: '#3C3F61',
        },
        '&:active': {
          backgroundColor: 'rgba(72, 96, 207, 0.1)',
          color: '#3C3F61',
        },
      },
      gutters: {
        paddingLeft: '5px',
        paddingRight: '5px',
      },
    },
    MuiListItemIcon: {
      root: {
        color: '#FFF',
        minWidth: 'auto',
        padding: '5px 0',
      },
    },
    MuiInputLabel: {
      root: {
        fontSize: 13,
        color: '#4e5054',
        lineHeight: 1.5,
        '&.$Mui-disabled': {
          color: '#4e5054',
        },
      },
      shrink: {
        fontSize: 16,
        color: '#4B403A',
        fontWeight: 700,
        display: 'none',
      },
      outlined: {
        transform: 'translate(10px, 7px) scale(1)',
      },
    },

    MuiOutlinedInput: {
      root: {
        border: 'transparent',
        borderRadius: 4,
        backgroundColor: '#fff',
      },
      input: {
        padding: '6.5px 8px',
      },
      inputMultiline: {
        borderRadius: 15,
        padding: '10px 15px',
        marginTop: 10,
        marginRight: 10,
        marginBottom: 10,
      },
      multiline: {
        padding: 0,
      },
      notchedOutline: {
        borderColor: 'transparent !important',
      },
      adornedEnd: {
        paddingRight: 0,
      },
    },

    MuiAutocomplete: {
      paper: {
        margin: '0',
      },
      listbox: {
        padding: '0',
      },
      option: {
        paddingLeft: '8px',
        paddingRight: '8px',
        lineHeight: '16px',
        '& .MuiFormControlLabel-root': {
          margin: 0,
          width: '100%',
          '& .MuiFormControlLabel-label': {
            flex: '1',
          },
        },
        '& .MuiCheckbox-root': {
          padding: 0,
        },
        '& .MuiCheckbox-colorSecondary.Mui-checked': {
          color: '#003c6f',
        },
        '&:hover': {
          backgroundColor: '#ffffff',
        },
        '&$checked': {
          backgroundColor: '#4B403A',
        },
        '& .MuiFormGroup-root': {
          '& .MuiRadio-colorSecondary.Mui-checked': {
            color: '#ff3e32',
          },
          '& .MuiFormControlLabel-root': {
            margin: '0',
            '& .MuiRadio-root': {
              padding: '0',
              '& .MuiIconButton-label': {
                marginRight: '5px',
              },
            },
          },
        },
      },
      inputRoot: {
        padding: '0 !important',
      },
      input: {
        color: '#4E5054',
        padding: '8.5px 4px !important',
        fontSize: '13px',
        '&:first-child': {
          paddingLeft: '6px !important',
        },
      },
    },

    MuiInputBase: {
      input: {
        fontSize: 16,
        color: '#4B403A',
        backgroundColor: '#fff',
        borderRadius: 15,
        fontWeight: 400,
        padding: 10,
        '&.$Mui-disabled': {
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          borderRadius: 4,
        },
      },
      multiline: {
        fontSize: 16,
        color: '#4B403A',
        backgroundColor: '#fff',
        borderRadius: 15,
        fontWeight: 400,
      },
    },
    MuiInput: {
      underline: {
        '&&&&:before': {
          borderBottom: '0px solid rgba(187, 187, 187, 1)',
        },
        '&&&&:after': {
          borderBottom: '0px solid rgba(187, 187, 187, 1)',
        },
      },
    },
    MuiFormControlLabel: {
      label: {
        fontSize: 13,
        fontWeight: 400,
        color: '#4e5054',
      },
    },
    MuiDialog: {
      paper: {
        backgroundColor: '#fdfeff',
      },
    },

    MuiSelect: {
      icon: {
        color: '#91979d',
        right: '5px',
      },
      outlined: {
        borderRadius: 15,
      },
      select: {
        borderRadius: 15,
        padding: '18.5px 14px',
        border: '1px solid #c4c4c4',
        boxShadow: '0px 0px 5px rgba(162,156,153,0.7)',
        '&:focus': {
          borderRadius: 15,
          backgroundColor: '#ffffff',
        },
      },
    },
    MuiCheckbox: {
      root: {
        color: '#92979d',
      },
    },
    MuiIconButton: {
      root: {
        color: '#92979d',
      },
      colorInherit: {
        color: '#003c6f',
      },
      colorSecondary: {
        color: '#000',
      },
    },

    MuiAvatar: {
      img: {
        width: 'auto',
        height: 'auto',
      },
    },

    // Right Panel
    MuiExpansionPanelSummary: {
      root: {
        backgroundColor: '#4B403A',
        color: '#ffffff',
      },
    },

    MuiExpansionPanelDetails: {
      root: {
        padding: '10px 0px 10px 0px',
      },
    },

    // Datepicker
    MuiPickersBasePicker: {
      pickerView: {
        width: 'auto',
        height: 'auto',
        maxWidth: 'auto',
        minWidth: 'auto',
        minHeight: 'auto',
        padding: '10px 20px 10px 20px',
      },
    },

    MuiPickersCalendarHeader: {
      switchHeader: {
        marginTop: '15px',
        marginBottom: '30px',
      },
    },

    // Chip

    MuiChip: {
      root: {
        boxShadow: '0px 0 5px rgba(0,0,0,0.3)',
        fontSize: 13,
      },
      sizeSmall: {
        fontSize: '16px',
      },
    },

    // Switch
    MuiSwitch: {
      root: {
        width: 41,
        height: 22,
        padding: 0,
        display: 'flex',
      },

      switchBase: {
        padding: 4,
        color: '#A29C99',
        '&$checked': {
          transform: 'translateX(20px)',
          color: '#003c6f !important',

          '& + $track': {
            opacity: 1,
            backgroundColor: '#fff!important',
            borderColor: '#003c6f',
            color: '#003c6f !important',
          },
        },
      },

      thumb: {
        width: 13,
        height: 13,
        boxShadow: 'none',
      },

      track: {
        border: '2px solid #A29C99',
        borderRadius: 30 / 2,
        opacity: 1,
        backgroundColor: '#fff',
      },
    },

    // Overrides style - modal dialog

    MuiDialogTitle: {
      root: {
        margin: 0,
        padding: '16px',
        textAlign: 'center',
      },
    },

    MuiDialogContent: {
      root: {
        overflow: 'auto',
        paddingTop: '0px',
        paddingBottom: '16px',
        paddingLeft: '16px',
        paddingRight: '16px',
        '& .MuiOutlinedInput-root': {
          border: '1px solid #000',
        },
      },
    },

    MuiDialogActions: {
      spacing: {
        paddingTop: '16px',
        paddingBottom: '30px',
        paddingLeft: '16px',
        paddingRight: '16px',
        justifyContent: 'center',
      },
    },

    // Chat

    MuiListItemText: {
      root: {
        width: 'inherit',
        marginLeft: 10,
      },
      primary: {
        fontSize: '13px',
        fontWeight: 'bold',
      },
    },

    // Overrides style - material ui data table

    MuiTable: {
      root: {
        borderRadius: '4px',
        overflow: 'hidden',
      },
    },

    MuiTableHead: {
      root: {
        '& .MuiButton-root': {
          minWidth: 'auto',
        },
        '& .MuiTableCell-head:first-child': {
          /* textAlign: 'left !important', */
          '& .MuiTableSortLabel-root': {
            marginLeft: '0',
          },
        },
        '& .MuiTableCell-head': {
          padding: '12px 6px !important',
          textAlign: 'center !important',
          '& .MuiTableSortLabel-root': {
            marginLeft: '18px',
          },
        },
        '& .MuiTableSortLabel-icon': {
          margin: '0px',
        },
      },
    },

    MuiTableCell: {
      root: {
        fontSize: 13,
        color: '#4e5054',
        fontWeight: '700',
        border: '1px solid #dee6ec',
        /* wordBreak: 'break-word', */
        padding: '12px 6px',
        '&:last-child': {
          /* paddingRight: '12px!important',
          width: '96px!important', */
          '& a': {
            color: '#003c6f',
          },
        },
      },

      head: {
        backgroundColor: '#e5ebf0 !important',
        color: '#4e5054',
        fontWeight: '700',
        fontSize: 13,
        whiteSpace: 'nowrap',
      },
    },

    MuiTableRow: {
      root: {
        fontSize: 13,
        color: '#19191a',
        fontWeight: '400',
        '&:hover': {
          backgroundColor: '#e2ddd8',
          color: '#4B403A',
        },
      },
      footer: {
        backgroundColor: '#f2f5f8',
        '&:hover': {
          backgroundColor: '#f2f5f8',
        },
        '& .MuiTableCell-footer': {
          border: 'none',
        },
      },
    },

    MuiTablePagination: {
      select: {
        backgroundColor: 'transparent',
        border: '0px solid #c4c4c4',
        boxShadow: '0px 0px 0px rgba(162,156,153,0.7)',
        lineHeight: '20px',
        color: '#4e5054',
        fontSize: 11,
        fontWeight: '400',
      },

      root: {
        '&:last-child': {
          width: '100%!important',
        },
      },
    },

    MuiBreadcrumbs: {
      separator: {
        color: '#809db7',
        fontSize: '18px',
      },
    },
    MuiAccordion: {
      root: {
        boxShadow: 'none',
        backgroundColor: '#e5ebf1',
        margin: '16px 0',
        '&&&&:before': {
          display: 'none',
        },
      },
      rounded: {
        borderRadius: 4,
      },
    },
    MuiAccordionSummary: {
      content: {
        margin: 0,
      },
    },
    MuiTab: {
      root: {
        minWidth: 'auto !important',
        fontWeight: '700',
        overflow: 'visible',
        padding: 0,
        marginRight: '20px',
      },
      textColorInherit: {
        color: '#616569',
      },
    },
    MuiTabs: {
      indicator: {
        height: '4px',
        backgroundColor: '#FF3E32',
        borderRadius: '1px',
      },
    },
    MuiBadge: {
      colorPrimary: {
        backgroundColor: '#FF3E32',
      },
      anchorOriginTopRightRectangle: {
        right: '-15px',
      },
    },
    MuiFormControl: {
      marginNormal: {
        marginTop: 0,
        marginBottom: 0,
      },
    },
  },
});

export default theme;
